var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type && _vm.duration && (_vm.instrument || _vm.event)
    ? _c("SoliAvatarBtn", {
        attrs: {
          title: _vm.lessonTitle,
          icon: "music_note",
          subtitleBottom: _vm.substitutePass
            ? "Reschedule as private lesson"
            : null,
          subtitleBottom2: _vm.duration + " min",
          blue: "",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }